// Links to a guide on the web app.
//
// guideLink      — the plain link (shown to the user, used for the guide's
//                  own URL field).
// guideShareLink — what the app's Share / Email / WhatsApp actions send:
//                  the same link tagged src=share, so the Admin Dashboard can
//                  tell a guide a user shared from a scan of a video's QR
//                  code (src=qr) or a link posted with its own code
//                  (2026-10-13). Old untagged links keep working.
export const guideLink = (guide_info_id) => `https://andiamoplaces.com?id=${guide_info_id}`;
export const guideShareLink = (guide_info_id) => `${guideLink(guide_info_id)}&src=share`;
